import { GridColumnType } from "../../../data/gridColumnType";

export const InvoiceApprovalConfig = {
  columns: [
   {
      name: "",
      fieldName: "select",
      allowShort: false,
      colType: GridColumnType.CHECKBOX,
      colSettings: {
        allowHeaderCheckbox: false,
        headerLabel: "Select All",
        allowEdit: true
      }
    },
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Approver Name",
      fieldName: "approverName",
      colType: GridColumnType.Text,
    },
    {
      name: "Cert Number",
      fieldName: "certNumber",
      colType: GridColumnType.Text,
    },
    {
      name: "Overseas",
      fieldName: "isOverseas",
      colType: GridColumnType.Text,
    },
    {
      name: "Country",
      fieldName: "countryName",
      colType: GridColumnType.Text,
    },
    {
      name: "Push to Xero",
      fieldName: "pushToXero",
      colType: GridColumnType.Text,
    },
    {
      name: "Manual Invoice Number",
      fieldName: "manualInvoiceNumber",
      colType: GridColumnType.Text,
    },
    {
      name: "Approval Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
  ],
};
